import uniqBy from 'lodash/uniqBy';
import { Product } from '../../types/magento';
import { BadgeIcon, XAppName, LogbadgeDownloadHeaders } from '../../types/badge';
import { MAX_PDF_ENTITLEMENT_ICONS } from '../../common/constants';
import { BADGE_DOWNLOAD_TYPE, PDFEntitlementIcon } from '../../types/enums';
import BadgeUtils from './badgeUtils';
import SortUtils from '../../common/utils/sortUtils';
import RingboxService from '../../services/RingboxService';

class MercuryUtils {
  static getMercuryQrCodeUrlWithBadgeToken = (badgeToken: string, registrationApiUrl: string) => {
    return `${registrationApiUrl}/v1/badges/qrCode?badgeToken=${badgeToken}`;
  };

  static async logBadgeDownloaded(qrCodeUrl: string, type: BADGE_DOWNLOAD_TYPE, apiUrl: string, headers?: LogbadgeDownloadHeaders) {
    try {
      await RingboxService.logBadgeDownloadedEvent(
        apiUrl,
        type,
        this.getUrlParam('badgeToken', qrCodeUrl) as string,
        headers
      );
    } catch (err) {
      console.error(err);
    }
  }

  static async logBadgeDownloadedSync(badgeToken: string, type: BADGE_DOWNLOAD_TYPE, apiUrl: string, xAppName: XAppName) {
    try {
      return await RingboxService.logBadgeDownloadedEventSync(
        apiUrl,
        type,
        badgeToken,
        xAppName
      );
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  static getUrlParam(name: string, url = '') {
    if (!url) url = window.location.href;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results == null ? null : results[1];
  };

  static getBadgeIconsOptions(product: Product) {
    return product.items
      .map((item) => item.options)
      .flat()
      .map(({ product }) => ({
        priority: product.rx_badge_icon_priority,
        name: product.rx_badge_icon
      }));
  }

  static getBadgeIcons(options: Array<BadgeIcon>): PDFEntitlementIcon[] {
    return uniqBy(options.sort(SortUtils.sortBadgeIconsByPriority), 'name')
      .filter((icon) => Boolean(icon.name))
      .sort(SortUtils.sortBadgeIconsByPriority)
      .slice(0, MAX_PDF_ENTITLEMENT_ICONS)
      .map(({ name }) => name) as Array<PDFEntitlementIcon>;
  }

  static getBadgeFileName(firstName: string, lastName: string) {
    return BadgeUtils.getPDFName(firstName, lastName);
  }

  static getImage(portalImageDomain: string, imageName: string, sku: string) {
    return BadgeUtils.getPortalImageUrl(portalImageDomain, imageName, sku);
  }

  static getVisaImage(portalImageDomain: string, imageName: string) {
    return BadgeUtils.getVisaImageUrl(portalImageDomain, imageName);
  }
}

export { MercuryUtils };
export default MercuryUtils;
